import { uniqBy, uniq } from 'lodash';

import rootStore from '@/store';
import { reportingService } from '@/angularBridgeCode/ringbaPortal.servicesModule';

export default class AgGridService {
  constructor() {
    this.gridCallback = () => [];
  }

  validateCurrentSettings() {
    return !!rootStore.getters['reporting/activeInsightTranslatedTimeZoneId'];
  }

  getRows({ request, successCallback, failCallback }) {
    if (!this.validateCurrentSettings()) {
      return successCallback([], 0);
    }
    
    let { apiRequestData, isTopLevelRowGroup } = this.getApiRequestData(request);

    // Avoid hitting API on empty groups
    if (apiRequestData.groupByColumns.length > 0) {
      return reportingService.loadInsightData(rootStore.state.currentAccountId, apiRequestData).then(({ records, allRecords, totalsRecord, partialResult }) => {
        records.forEach((r, index) => {
          r.agGridHash = this.#getRowDataHash(r, index, apiRequestData.groupByColumns);
        });
    
        successCallback(records, records?.length);
        this.gridCallback(records, isTopLevelRowGroup, totalsRecord, partialResult, allRecords);
      }).catch(failCallback);
    }

    successCallback([], 0);
    this.gridCallback([], false);
  }

  setGridCallback(callback) {
    this.gridCallback = callback;
  }

  getApiRequestData(request) {
    const timezoneId = rootStore.getters['reporting/activeInsightTranslatedTimeZoneId'];
    const { reportStart, reportEnd } = reportingService.getReportingDateRange(
      rootStore.getters['reporting/activeInsightTimeRange'],
      timezoneId
    );

    const noOfgroupKeys = (request.groupKeys && request.groupKeys.length) || 0;

    const filters = [
      ...reportingService.getFilterFromFilterCriteria(rootStore.getters['reporting/activeInsight'].settings.filterCriteria)
    ];

    const lookUp = {};
    request.rowGroupCols.reduce((lU, c) => (lU[c.id] = true, lU), lookUp);
    request.valueCols.reduce((lU, c) => (lU[c.field] = true, lU), lookUp);
    let sortModel = request.sortModel.filter(s => lookUp[s.colId]);

    let valueColumns = uniqBy(request.valueCols, 'field');

    return {
      apiRequestData: {
        reportStart,
        reportEnd,
        groupKeys: request.groupKeys,
        groupByColumns: request.rowGroupCols ? request.rowGroupCols.map(col => {
          return {
            column: col.field,
            displayName: col.headerName
          };
        }) : [],
        valueColumns: valueColumns ? valueColumns.map(col => {
          return {
            column: col.field,
            displayName: col.headerName,
            aggregateFunction: col.aggFunc
          };
        }) : [],
        orderByColumns: sortModel.map(sort => (
          { column: sort.colId, direction: sort.sort }
        )),
        filters,
        formatTimeZone: timezoneId,
        formatTimespans: true,
        formatPercentages: true,
        generateRollups: true
      },
      isTopLevelRowGroup: noOfgroupKeys === 0
    };
  }

  #getRowDataHash(data, index, groupCols) {
    const hashKeys = uniq([
      'campaignName', 'campaignId', 'publisherName', 'publisherId', 'publisherSubId', 'affiliateName', 'affiliateId', 'affiliateSubId', 'inboundPhoneNumber', 'number', 'numberId',
      'numberPoolName', 'numberPoolId', 'targetId', 'targetName', 'targetNumber', 'buyer', 'buyerId', 'targetGroupId', 'targetGroupName'
    ].concat(groupCols.map(col => col.column)));

    let hash =  index + '::';
    for (let i = 0; i < hashKeys.length; i++) {
      const key = hashKeys[i];

      if (typeof data[key] !== 'undefined') {
        hash += i + ':' + data[key] + ':';
      }
    }

    return hash;
  }
}